import { useCallback, useMemo } from 'react'
import I18n from "../../localization";
import { Button } from '@material-ui/core'
import Icon from '../../utils/icons.js'
import { useMobileStyles } from "./styles.js"
import { ENERGY_SOURCE } from '../../utils/constant.js'

function EnergyPagePopup(props) {
  const { isIQAirOnly, redirectToProfile, redirectToTariff, closePopup, energySource, isDarkMode } = props
  const classes = useMobileStyles()
  const energySourceNotCompatible = ![ENERGY_SOURCE.ELECTRIC, ENERGY_SOURCE.HYBRID].includes(energySource)

  const handleNegativeAction = useCallback(() => {
    closePopup()
  }, [closePopup])

  const handlePositiveAction = useCallback(() => {
    if(!energySourceNotCompatible) {
      (isIQAirOnly ? redirectToTariff : redirectToProfile)();
    }
    closePopup()
  }, [closePopup, isIQAirOnly, redirectToProfile, redirectToTariff, energySourceNotCompatible])

  const popupDetails = useMemo(() => {
    
    if(energySourceNotCompatible) {
      return {
        title: I18n.t('mobile.iqAirSetting.energyPopup.title1'),
        buttons: <Button className={classes.positiveActionButton} onClick={handlePositiveAction}>{I18n.t('mobile.iqAirSetting.energyPopup.okGotIt')}</Button>
      }
    } 

    return {
      title: isIQAirOnly ? I18n.t('mobile.iqAirSetting.energyPopup.title2') : I18n.t('mobile.iqAirSetting.energyPopup.title3'),
      buttons:  <>
        <Button className={classes.positiveActionButton} onClick={handlePositiveAction}>{isIQAirOnly ? I18n.t("mobile.iqAirSetting.energyPopup.updateRates") : I18n.t("mobile.iqAirSetting.energyPopup.updateProfile")}</Button>
        <Button className={classes.negativeActionButton} onClick={handleNegativeAction}>{I18n.t("mobile.iqAirSetting.energyPopup.cancel")}</Button>
      </>
    }
    
  }, [energySourceNotCompatible, isIQAirOnly, handleNegativeAction, handlePositiveAction])

  return (
    <div className={classes.energyModePopupContainer}>
      <div className={classes.energyModeIconContainer}>
          <Icon src="info" isDarkMode={isDarkMode} width={64} height={64} />
      </div>
      <div className={classes.energyModeDescContainer}>
        {popupDetails.title}
      </div>
      <div className={classes.energyModeActionContainer}>
        {popupDetails.buttons}
      </div>
    </div>
  )
}

export default EnergyPagePopup
